import { render, staticRenderFns } from "./DiagramChooseType.vue?vue&type=template&id=130bc8ad&"
import script from "./DiagramChooseType.vue?vue&type=script&lang=js&"
export * from "./DiagramChooseType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports